import * as React from 'react';
import { isEmpty } from 'ramda';

import { useMultiSelectFilter } from '@/scopes/search/search/domain/hooks';
import { useQuickSearchStore } from '@/scopes/search/components/QuickSearchBar/store';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { createSearchFilterClickEvent } from '@/scopes/search/search/domain/analytics';
import { DepartureAirportFilter } from '@/scopes/search/components/DepartureAirportFilter';

export function DepartureAirportQuickSearchItemFilter() {
  const { isFetching, options, setSelection, selectedValues } = useMultiSelectFilter('DepartureAirport');
  const [localSelectedValue, setLocalSelectedValue] = React.useState(selectedValues);
  const { setActiveItem } = useQuickSearchStore();
  const { sendEvent } = useAnalytics();

  const handleConfirm = () => {
    if (!isFetching) {
      setSelection(localSelectedValue);

      if (localSelectedValue.length) {
        sendEvent(
          createSearchFilterClickEvent({
            element: 'checkbox',
            type: 'airports',
            result: localSelectedValue.join(','),
          })
        );
      }
    }
    setActiveItem(null);
  };

  if (isEmpty(options)) {
    return null;
  }

  return (
    <DepartureAirportFilter
      onClose={handleConfirm}
      options={options}
      selectedValues={localSelectedValue}
      onSelectedValueChange={setLocalSelectedValue}
      disabled={isFetching}
    />
  );
}
